<template>
    <div class="card" :class="customClasses">
        <div class="card-body">
            <h4 class="card-title">{{ cardTitle }}</h4>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'OCard',
    props: [
        'cardTitle',
        'class'
    ],
    data() {
        return {
            customClasses: null
        }
    },
    mounted() {
        this.customClasses = this.class;
    }
}
</script>